import * as React from 'react';
import { ParallaxMedia } from './mediaAnimationParallax';
import { VerticalSlideshow } from './mediaAnimationSlideshow';
// eslint-disable-next-line no-shadow
export var AnimationStyle;
(function (AnimationStyle) {
    AnimationStyle[AnimationStyle["verticalSlideshow"] = 0] = "verticalSlideshow";
    AnimationStyle[AnimationStyle["parallax"] = 1] = "parallax";
})(AnimationStyle || (AnimationStyle = {}));
export function MediaAnimation(_a) {
    var urls = _a.urls, style = _a.style;
    if (style === AnimationStyle.parallax) {
        return React.createElement(ParallaxMedia, { urls: urls });
    }
    return React.createElement(VerticalSlideshow, { urls: urls });
}
